export const Configs = {
	BASE_URL: process.env.REACT_APP_API_URI,
	API_KEY: process.env.REACT_APP_API_KEY,
	PAYSTACK: process.env.REACT_APP_PAYSTACK_KEY,
	REACT_APP_MARCHANT_CODE: process.env.REACT_APP_MARCHANT_CODE,
	PAYMENT_ID: process.env.REACT_APP_PAYMENT_ID,
};
